import { createStore, get, set } from "idb-keyval";

// Dedicated IndexedDB store (own DB name) so the offline write queue never
// collides with any other client-side storage the app grows later.
const store = createStore("hayloft-offline", "queue-store");

const QUEUE_KEY = "mutation-queue";

export async function readQueueRaw<T>(): Promise<T[]> {
  const value = await get<T[]>(QUEUE_KEY, store);
  return value ?? [];
}

export async function writeQueueRaw<T>(items: T[]): Promise<void> {
  await set(QUEUE_KEY, items, store);
}
